"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facilities = void 0;
const sdk_1 = require("../sdk");
var Facilities;
(function (Facilities) {
    Facilities.all = (options) => {
        const url = '/facilities/all';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Facilities.list = (options) => {
        const url = '/facilities';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Facilities.create = (data) => {
        const url = '/facilities';
        return sdk_1.SDK.axios.post(url, data);
    };
    Facilities.get = (facilityId) => {
        const url = `/facilities/${facilityId}`;
        return sdk_1.SDK.axios.get(url);
    };
    Facilities.update = (facilityId, data) => {
        const url = `/facilities/${facilityId}`;
        return sdk_1.SDK.axios.put(url, data);
    };
    Facilities.remove = (facilityId) => {
        const url = `/facilities/${facilityId}`;
        return sdk_1.SDK.axios.delete(url);
    };
})(Facilities = exports.Facilities || (exports.Facilities = {}));
//# sourceMappingURL=facilities.js.map